module.exports = __webpack_public_path__ + "static/media/hero-order-fr.5b867c35.png";